export const ADMINISTRATIVE_AREAS_LOADED =
  'contactInfo/ADMINISTRATIVE_AREAS_LOADED';
export const ADMINISTRATIVE_AREA_CHANGED =
  'contactInfo/ADMINISTRATIVE_AREA_CHANGED';
export const COMPLETE_STEP = 'contactInfo/COMPLETE_STEP';
export const COUNTRY_CHANGED = 'contactInfo/COUNTRY_CHANGED';
export const CITIZENSHIP_CHANGED = 'contactInfo/CITIZENSHIP_CHANGED';
export const FIELD_BLURRED = 'contactInfo/FIELD_BLURRED';
export const FIELD_CHANGED = 'contactInfo/FIELD_CHANGED';
export const INIT_DATA_LOADED = 'contactInfo/INIT_DATA_LOADED';
export const LOCAL_STORAGE_LOADED = 'contactInfo/LOCAL_STORAGE_LOADED';
export const LOCAL_STORAGE_SYNCED = 'contactInfo/LOCAL_STORAGE_SYNCED';
export const SHOW_ORCID_DIALOG = 'contactInfo/SHOW_ORCID_DIALOG';

export const administrativeAreasLoaded = administrativeAreas => ({
  type: ADMINISTRATIVE_AREAS_LOADED,
  administrativeAreas,
});
export const initDataLoaded = (countries, administrativeAreas) => ({
  type: INIT_DATA_LOADED,
  countries,
  administrativeAreas,
});
export const localStorageLoaded = data => ({
  type: LOCAL_STORAGE_LOADED,
  data,
});
export const localStorageSynced = () => ({ type: LOCAL_STORAGE_SYNCED });



// WEBPACK FOOTER //
// ./src/contact-info/contactInfoActions.js